import styled from '@emotion/styled';
import dateFnsGenerateConfig from 'rc-picker/lib/generate/dateFns';
import generatePicker from 'antd/es/date-picker/generatePicker';

const DatePicker = generatePicker(dateFnsGenerateConfig);

export const SadaKDatePicker = styled(DatePicker)``;
